import { Box, IconButton, Typography } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import dayjs from "dayjs";
import { FC, useContext } from "react";

import { CellContext } from "../CalendarGrid";

const CellManageHeader: FC = () => {
  const { selectedCellDate, closeModal } = useContext(CellContext);

  return (
    <Box my={1} display="flex" alignItems="center" justifyContent="space-between">
      <Box>
        <Typography variant="h5">Coach Available Dates</Typography>
      </Box>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="h6" color="textSecondary">
          {dayjs(selectedCellDate).format("MMMM DD, YYYY")}
        </Typography>

        <IconButton onClick={closeModal}>
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default CellManageHeader;
